module.exports = __webpack_public_path__ + "img/27.4ce93e30.png";